var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"google",on:{"click":_vm.loginWithGoogle}},[_vm._v(" Accedi con Google ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }